export class PreInvoiceOneOfFee {
  id: number | undefined
  oneOfFee: object | null
  preInvoice: object | null
  dateFrom: Date | string
  dateTo: Date | string

  constructor() {
    this.oneOfFee = null
    this.preInvoice = null
    this.dateFrom = ''
    this.dateTo = ''
  }
}
